@if (component) {
<div class="w-10 w-12-m w-12-s p-b-10-s">
    <div class="wrap-l wrap-x"
         [grid]="[1, 2, 2, 2][client.sizeId]"
         [gridColumnGap]="[0, 12, 12, 12][client.sizeId]"
         [gridRowGap]="[14, 0, 0, 0][client.sizeId]">
        @for (category of component.categories; track $index) {
        <div>
            <href [link]="category.url"
                  class="block">

                <div class="ratio-4-3 m-b-4">
                    <img [image]="category.image"
                         class="rf">
                </div>
                <p class="p-b-2 h3"
                   *iCms="'title' of category">
                </p>
                <p class="p-b-2 p1"
                   *iCms="'subtitle' of category; skipEmpty: true">
                </p>
            </href>
            @if (category.ctaCopy) {
            <href [link]="category.ctaUrl">
                <button class="button m-t-4">
                    <span *iCms="'ctaCopy' of category">
                    </span>
                </button>
            </href>
            }
        </div>
        }
    </div>
</div>
}